import { createSelector } from 'reselect';
import { getUserId } from 'ha/modules/AuthLogic/selectors';
import { getAdvertiser } from '../reducer';

const isAdvertiserOwner = createSelector(
  [getUserId, getAdvertiser],
  (currentUserId, advertiser) => currentUserId === advertiser.id,
);

export { isAdvertiserOwner };
